const page_top_array = [
    {
        id: 1,
        alt: "Sobre o treino.",
        imgURL: "images/treino-orientado.jpg",
        text: "Treino Orientado"
    },
    {
        id: 2,
        alt: "Sobre o treinador",
        imgURL: "images/treinador-experiente.jpg",
        text: "Treinador Experiente"
    },
    {
        id: 3,
        alt: "Sobre o preço.",
        imgURL: "images/preco-amigavel.jpg",
        text: "Preço Amigável"
    },
];

export default page_top_array;